module.exports = __webpack_public_path__ + "static/media/square.dc337cf5.webp";